import React, { useEffect, useState } from 'react';
import api from '../api';
import { useAdminLanguage } from '../AdminLanguageContext';

const yuan = (cents) => (Number(cents || 0) / 100).toFixed(2);

export default function Wallets() {
  const { copy } = useAdminLanguage();
  const walletsCopy = copy.wallets;
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [keyword, setKeyword] = useState('');

  const [modalOpen, setModalOpen] = useState(false);
  const [modalUser, setModalUser] = useState(null);
  const [adjustYuan, setAdjustYuan] = useState('');
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState('');

  const load = () => {
    setLoading(true);
    api.get('/admin/finance/wallets', { params: { keyword, limit: 50 } })
      .then(r => setUsers(r.data.users || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const openAdjust = (user) => {
    setModalUser(user);
    setAdjustYuan('');
    setReason('');
    setErr('');
    setModalOpen(true);
  };

  const submit = () => {
    const yuanAmount = Number(adjustYuan);
    if (!yuanAmount || !reason.trim()) { setErr(walletsCopy.errors.requiredFields); return; }
    setSubmitting(true);
    api.post(`/admin/finance/users/${modalUser.id}/adjust`, {
      amount: Math.round(yuanAmount * 100),
      reason: reason.trim(),
    })
      .then(() => {
        setModalOpen(false);
        load();
      })
      .catch(e => setErr(e.response?.data?.error || e.message))
      .finally(() => setSubmitting(false));
  };

  const totalBalance = users.reduce((s, u) => s + (u.balance || 0), 0);
  const totalFrozen  = users.reduce((s, u) => s + (u.frozen || 0), 0);

  return (
    <div>
      <div className="page-title">💰 {walletsCopy.title}</div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 20 }}>
        <div className="card stat-card"><div className="stat-label">{walletsCopy.stats.users}</div><div className="stat-value">{users.length}</div></div>
        <div className="card stat-card"><div className="stat-label">{walletsCopy.stats.totalBalance}</div><div className="stat-value" style={{ color: '#1dbf73' }}>¥ {yuan(totalBalance)}</div></div>
        <div className="card stat-card"><div className="stat-label">{walletsCopy.stats.totalFrozen}</div><div className="stat-value" style={{ color: '#f59e0b' }}>¥ {yuan(totalFrozen)}</div></div>
      </div>

      <div className="card">
        <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
          <div className="search-input" style={{ flex: 1 }}>
            <input
              placeholder={walletsCopy.searchPlaceholder}
              value={keyword}
              onChange={e => setKeyword(e.target.value)}
              onKeyUp={e => e.key === 'Enter' && load()}
            />
          </div>
          <button className="btn btn-outline" onClick={load}>🔍 {walletsCopy.search}</button>
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>{walletsCopy.columns.id}</th><th>{walletsCopy.columns.user}</th><th>{walletsCopy.columns.email}</th>
                <th>{walletsCopy.columns.balance}</th><th>{walletsCopy.columns.frozen}</th><th>{walletsCopy.columns.points}</th><th>{walletsCopy.columns.createdAt}</th><th>{walletsCopy.columns.actions}</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: 32, color: '#9ca3af' }}>{walletsCopy.loading}</td></tr>
              ) : users.length === 0 ? (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: 32, color: '#9ca3af' }}>{walletsCopy.empty}</td></tr>
              ) : users.map(u => (
                <tr key={u.id}>
                  <td style={{ color: '#9ca3af' }}>#{u.id}</td>
                  <td style={{ fontWeight: 600 }}>{u.username}</td>
                  <td style={{ color: '#6b7280' }}>{u.email}</td>
                  <td style={{ color: '#1dbf73', fontWeight: 700 }}>¥ {yuan(u.balance)}</td>
                  <td style={{ color: '#f59e0b', fontWeight: 700 }}>¥ {yuan(u.frozen)}</td>
                  <td>{u.points || 0}</td>
                  <td style={{ color: '#6b7280', fontSize: 12 }}>{u.created_at ? String(u.created_at).slice(0, 10) : walletsCopy.emptyValue}</td>
                  <td>
                    <button className="btn btn-sm btn-outline" onClick={() => openAdjust(u)}>⚙️ {walletsCopy.actions.adjust}</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {modalOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }} onClick={() => setModalOpen(false)}>
          <div className="card" style={{ width: 460, maxWidth: '90vw' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: 0, marginBottom: 14 }}>{walletsCopy.adjustModal.title(modalUser.username)}</h3>
            <div style={{ background: '#f9fafb', padding: 12, borderRadius: 6, marginBottom: 14, fontSize: 13 }}>
              {walletsCopy.adjustModal.currentBalance}: <strong style={{ color: '#1dbf73' }}>¥ {yuan(modalUser.balance)}</strong>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>{walletsCopy.adjustModal.amountLabel}</label>
              <input type="number" step="0.01" placeholder={walletsCopy.adjustModal.amountPlaceholder}
                value={adjustYuan} onChange={e => setAdjustYuan(e.target.value)}
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>{walletsCopy.adjustModal.reasonLabel}</label>
              <input type="text" placeholder={walletsCopy.adjustModal.reasonPlaceholder}
                value={reason} onChange={e => setReason(e.target.value)}
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }} />
            </div>
            {err && <div style={{ background: '#fef2f2', color: '#991b1b', padding: 8, borderRadius: 4, marginBottom: 12, fontSize: 13 }}>{err}</div>}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button className="btn btn-outline" onClick={() => setModalOpen(false)}>{walletsCopy.actions.cancel}</button>
              <button className="btn btn-primary" onClick={submit} disabled={submitting}>
                {submitting ? walletsCopy.actions.processing : walletsCopy.actions.confirm}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
